import { render, staticRenderFns } from "./FormCategory.vue?vue&type=template&id=056dd1fc&scoped=true"
import script from "./FormCategory.vue?vue&type=script&lang=js"
export * from "./FormCategory.vue?vue&type=script&lang=js"
import style0 from "./FormCategory.vue?vue&type=style&index=0&id=056dd1fc&prod&lang=styl&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056dd1fc",
  null
  
)

export default component.exports